import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import type { ButtonProps } from './Button.types';
import './Button.scss';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled,
    iconLeft,
    iconRight,
    fullWidth,
    className,
    type,
    children,
    ...rest
  },
  ref,
) {
  const classes = [
    'button',
    `button--${variant}`,
    `button--${size}`,
    fullWidth ? 'button--full' : '',
    loading ? 'button--loading' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type={type || 'button'}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="button__spinner" aria-hidden="true">
          <Loader2 size={16} />
        </span>
      ) : iconLeft ? (
        <span className="button__icon button__icon--left" aria-hidden="true">
          {iconLeft}
        </span>
      ) : null}
      {children ? <span className="button__label">{children}</span> : null}
      {!loading && iconRight ? (
        <span className="button__icon button__icon--right" aria-hidden="true">
          {iconRight}
        </span>
      ) : null}
    </button>
  );
});

export default Button;
